import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const ManagementFinancial = Loader(
  lazy(() => import('content/financial/invoices')),
);

const FinancialReceipts = Loader(
  lazy(() => import('content/financial/receipts')),
);

const ManagementBoletos = Loader(lazy(() => import('content/boletos')));

const financialRoutes = [
  {
    path: '',
    element: <Navigate to="/financial" replace />,
  },
  {
    path: 'invoice',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <ManagementFinancial />,
      },
    ],
  },
  {
    path: 'receipt',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <FinancialReceipts />,
      },
    ],
  },
  {
    path: 'boleto',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <ManagementBoletos />,
      },
    ],
  },
];

export default financialRoutes;
